"use strict";

require("core-js/modules/es.symbol");

require("core-js/modules/es.symbol.description");

require("core-js/modules/es.symbol.iterator");

require("core-js/modules/es.array.concat");

require("core-js/modules/es.array.filter");

require("core-js/modules/es.array.for-each");

require("core-js/modules/es.array.from");

require("core-js/modules/es.array.iterator");

require("core-js/modules/es.array.map");

require("core-js/modules/es.array.reduce");

require("core-js/modules/es.array.slice");

require("core-js/modules/es.function.name");

require("core-js/modules/es.number.to-fixed");

require("core-js/modules/es.object.assign");

require("core-js/modules/es.object.get-own-property-descriptor");

require("core-js/modules/es.object.get-own-property-descriptors");

require("core-js/modules/es.object.get-prototype-of");

require("core-js/modules/es.object.keys");

require("core-js/modules/es.object.to-string");

require("core-js/modules/es.reflect.construct");

require("core-js/modules/es.regexp.exec");

require("core-js/modules/es.regexp.to-string");

require("core-js/modules/es.string.iterator");

require("core-js/modules/es.string.replace");

require("core-js/modules/web.dom-collections.for-each");

require("core-js/modules/web.dom-collections.iterator");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.getMimeType = exports.getFileExtension = exports.humanisedFileSize = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _superagent = _interopRequireDefault(require("superagent"));

var _moment = _interopRequireDefault(require("moment"));

var _FileUtils = _interopRequireDefault(require("@icare/core/lib/utils/FileUtils"));

var _Modal = require("../Modal");

var _FileUpload = _interopRequireDefault(require("../FileUpload"));

var _FileList = require("../FileList");

var _FileInputErrorCode = _interopRequireDefault(require("../FileInput/FileInputErrorCode"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var DEFAULT_MAX_FILE_SIZE = 10000000;
var DEFAULT_MAX_FILE_NAME_LENGTH = 80;
var DEFAULT_MAX_FILE_NAME_TOKEN = '<LENGTH>';

var estimateUploadEta = function estimateUploadEta(startTime, currentTime, completion) {
  var elapsed = currentTime - startTime;
  return Math.max(1 / (completion / 100) * elapsed - elapsed, 1);
}; // Modified from https://stackoverflow.com/questions/15900485/correct-way-to-convert-size-in-bytes-to-kb-mb-gb-in-javascript


var humanisedFileSize = function humanisedFileSize(sizeInBytes) {
  var decimals = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

  // The fileSize might already be a human readable if it's coming from an API etc.
  if (typeof sizeInBytes === 'string') {
    return sizeInBytes.toUpperCase();
  }

  if (sizeInBytes === 0) {
    return '0 Bytes';
  }

  var k = 1000;
  var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
  var i = Math.floor(Math.log(sizeInBytes) / Math.log(k));
  var n = parseFloat((sizeInBytes / Math.pow(k, i)).toFixed(decimals));
  var unit = sizes[i];
  return "".concat(n).concat(unit);
};

exports.humanisedFileSize = humanisedFileSize;

var getFileExtension = function getFileExtension(fileName) {
  var extensionRegex = /(?:\.([^.]+))?$/; // https://stackoverflow.com/questions/680929/how-to-extract-extension-from-filename-string-in-javascript

  return extensionRegex.exec(fileName)[1];
};

exports.getFileExtension = getFileExtension;

var getMimeType = function getMimeType(fileName) {
  return _FileUtils.default.getMimeType(getFileExtension(fileName));
};

exports.getMimeType = getMimeType;

var S3BucketUpload = /*#__PURE__*/function (_React$Component) {
  _inherits(S3BucketUpload, _React$Component);

  var _super = _createSuper(S3BucketUpload);

  function S3BucketUpload(props) {
    var _this;

    _classCallCheck(this, S3BucketUpload);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "handleRemoveUploadedFile", function (file, fileIndex) {
      var method = file.removeLocation.method;
      var url = file.removeLocation.url;
      var confirmed = confirm(_this.props.confirmRemovalMessage);

      if (confirmed) {
        var fileId = _this.getNextRemovingFileId();

        _this.updateRemovingState(fileId, true);

        (0, _superagent.default)(method, url).type(file.fileType).then(function () {
          _this.updateRemovingState(fileId, false);

          _this.props.onFilesChanged(_this.removeFile(fileIndex));
        }).catch(function (error) {
          console.error(error);

          _this.updateRemovingState(fileId, false);
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "handleUploadError", function (fileId) {
      _this.updateUploadState(fileId, {
        uploadStatus: _FileList.File.Status.ERROR,
        uploadProgress: 1,
        uploadMessage: _this.props.uploadErrorMessage,
        canRemove: true
      });

      _this.updateBusyState(fileId, false);
    });

    _defineProperty(_assertThisInitialized(_this), "handleCancelUpload", function (fileId) {
      var uploadRequest = _this.uploadRequests[fileId];

      if (uploadRequest && uploadRequest.abort) {
        uploadRequest.abort();
        delete _this.uploadRequests[fileId];
      }

      _this.updateUploadState(fileId, {
        removed: true
      });

      _this.updateBusyState(fileId, false);
    });

    _defineProperty(_assertThisInitialized(_this), "handleAcceptFiles", function () {
      var files = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var onRequestAttachmentLocations = _this.props.onRequestAttachmentLocations;

      if (typeof onRequestAttachmentLocations === 'function') {
        files.forEach(function (file) {
          // Create an ID for this new file, the ID is only meant to be used internally within this component.
          var fileId = _this.getNextUploadingFileId();

          _this.updateBusyState(fileId, true); // Set the initial state of the file. We do this before requesting locations to give the user immediate feedback.


          _this.updateUploadState(fileId, {
            fileData: file,
            uploadProgress: 0,
            uploadStatus: _FileList.File.Status.LOADING,
            uploadMessage: 'Starting upload...',
            canRemove: false
          }); // Request the upload, download and remove locations for this file from the parent component and store them in state.
          // Each location is in the format { method: "PUT", url: "endpoint/for/method" }
          // It is up to each user of this component to return the locations in the correct format.


          onRequestAttachmentLocations(file).then(function (_ref) {
            var upload = _ref.upload,
                download = _ref.download,
                remove = _ref.remove,
                objectKey = _ref.objectKey;

            _this.updateUploadState(fileId, {
              uploadLocation: upload,
              removeLocation: remove,
              downloadLocation: download,
              objectKey: objectKey
            }); // Now that we have the upload location, we can start the upload to S3


            _this.uploadFile(fileId, file, upload.method, upload.url);
          }).catch(function (error) {
            console.error(error);

            _this.handleUploadError(fileId);
          });
        });
      } else {
        console.warn('S3BucketUpload: no onRequestAttachmentLocations function implemented');
      }
    });

    _defineProperty(_assertThisInitialized(_this), "getFileRejectReasonMessage", function (file, propsValue) {
      var minSizeInBytes = propsValue.minSizeInBytes,
          minSizeErrorMessage = propsValue.minSizeErrorMessage,
          maxSizeInBytes = propsValue.maxSizeInBytes,
          maxSizeErrorMessage = propsValue.maxSizeErrorMessage,
          unsupportedFileTypeErrorMessage = propsValue.unsupportedFileTypeErrorMessage,
          maxFileNameLength = propsValue.maxFileNameLength;
      var message = null;

      var _file$errors = _slicedToArray(file.errors, 1),
          first = _file$errors[0];

      if (file.size < minSizeInBytes) {
        message = minSizeErrorMessage;
      } else if (file.size > maxSizeInBytes) {
        message = maxSizeErrorMessage;
      } else if (first.code === _FileInputErrorCode.default.FILE_NAME_LARGE_CODE) {
        message = _FileInputErrorCode.default.FILE_NAME_LARGE_MESSAGE.replace(DEFAULT_MAX_FILE_NAME_TOKEN, maxFileNameLength);
      } else {
        // It's assumed the only other reason is an unsupported file type.
        message = unsupportedFileTypeErrorMessage;
      }

      return message;
    });

    _defineProperty(_assertThisInitialized(_this), "handleRejectFiles", function () {
      var files = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      files.forEach(function (file) {
        //const errorMeesage = this.getFileRejectReasonMessage(file);
        var errorMeesage = _this.getFileRejectReasonMessage(file, _this.props);

        if (errorMeesage !== null) {
          (0, _Modal.alert)({
            message: errorMeesage
          });
        }
      });
    });

    _this.uploadingFileIdCount = 0;
    _this.removingFileIdCount = 0;
    _this.state = {
      uploadingFiles: {},
      uploadingStates: {},
      removingStates: {}
    };
    _this.uploadRequests = {};
    return _this;
  }

  _createClass(S3BucketUpload, [{
    key: "getNextUploadingFileId",
    value: function getNextUploadingFileId() {
      this.uploadingFileIdCount += 1;
      return "uploadingFile_".concat(this.uploadingFileIdCount);
    }
  }, {
    key: "getNextRemovingFileId",
    value: function getNextRemovingFileId() {
      this.uploadingFileIdCount += 1;
      return "removingFile_".concat(this.uploadingFileIdCount);
    }
    /**
     * Returns a new list of uploaded files with the new file added.
     */

  }, {
    key: "addFile",
    value: function addFile(file) {
      return [].concat(_toConsumableArray(this.props.uploadedFiles), [{
        fileName: file.fileData.name,
        fileType: file.fileData.type || getMimeType(file.fileData.name),
        fileSize: file.fileData.size,
        objectKey: file.objectKey,
        uploadLocation: file.uploadLocation,
        removeLocation: file.removeLocation,
        downloadLocation: file.downloadLocation
      }]);
    }
    /**
     * Returns a new list of uploaded files with the specified index removed.
     * @param fileIndex - position of the file in prop.uploadedFiles
     */

  }, {
    key: "removeFile",
    value: function removeFile(fileIndex) {
      return [].concat(_toConsumableArray(this.props.uploadedFiles.slice(0, fileIndex)), _toConsumableArray(this.props.uploadedFiles.slice(fileIndex + 1)));
    }
    /**
     * Call the files remove location to remove it.
     * @param file
     * @param fileIndex - position of the file in prop.uploadedFiles
     */

  }, {
    key: "getUploadedFiles",

    /**
     * Get a list of *uploaded* files in the format expected by <FileList />
     *
     * @returns {Object}
     */
    value: function getUploadedFiles() {
      var _this2 = this;

      return (this.props.uploadedFiles || []).map(function (file, i) {
        return {
          id: "uploadedFile_".concat(file.id || i),
          fileName: file.fileName,
          fileExtension: getFileExtension(file.fileName) || file.fileType,
          fileSize: file.fileSize ? humanisedFileSize(file.fileSize) : null,
          canRemove: !!file.removeLocation,
          onRemove: function onRemove() {
            _this2.handleRemoveUploadedFile(file, i);
          }
        };
      });
    }
    /**
     * Get a list of *uploading* files in the format expected by <FileList />
     *
     * Removed and completed uploads are filtered from this list.
     * @returns {Object}
     */

  }, {
    key: "getUploadingFiles",
    value: function getUploadingFiles() {
      var _this3 = this;

      return Object.keys(this.state.uploadingFiles).filter(function (key) {
        var uploadingFile = _this3.state.uploadingFiles[key];
        return !uploadingFile.removed && !uploadingFile.complete;
      }).map(function (key) {
        var uploadingFile = _this3.state.uploadingFiles[key];
        return {
          id: key,
          fileName: uploadingFile.fileData.name,
          fileExtension: getFileExtension(uploadingFile.fileData.name) || uploadingFile.fileData.type,
          fileSize: humanisedFileSize(uploadingFile.fileData.size),
          uploadProgress: uploadingFile.uploadProgress,
          uploadStatus: uploadingFile.uploadStatus,
          uploadMessage: uploadingFile.uploadMessage,
          canRemove: uploadingFile.canRemove,
          onRemove: function onRemove() {
            _this3.handleCancelUpload(key);
          }
        };
      });
    }
    /**
     * Convenience method for setting the state of an uploading file
     *
     * Uploading file state takes the form:
     * {
     *    fileData: <File object - https://developer.mozilla.org/en-US/docs/Web/API/File>,
     *    uploadLocation: { method, url },
     *    removeLocation: { method, url },
     *    downloadLocation: { method, url },
     *    uploadProgress: 0 - 1,
     *    uploadStatus: File.Status,
     *    uploadMessage: string,
     *    canRemove: bool,
     *    complete: bool, tracks whether the file has been removed/cancelled or not
     *    removed: bool, tracks whether the upload has completed or not
     * }
     *
     * @param fileId
     * @param {object} uploadState - will overwrite any existing keys, but leave others intact, just like a normal setState.
     * @param {function} callback - optional callback to hook into the setState callback.
     */

  }, {
    key: "updateUploadState",
    value: function updateUploadState(fileId, uploadState) {
      var callback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};
      this.setState(function (prevState) {
        var currentFileState = prevState.uploadingFiles[fileId] || {};
        var newUploadState = uploadState;

        if (typeof uploadState === 'function') {
          newUploadState = uploadState(currentFileState);
        }

        return {
          uploadingFiles: _objectSpread(_objectSpread({}, prevState.uploadingFiles), {}, _defineProperty({}, "".concat(fileId), _objectSpread(_objectSpread({}, currentFileState), newUploadState)))
        };
      }, callback);
    }
  }, {
    key: "isBusy",
    value: function isBusy() {
      var _this4 = this;

      return Object.keys(this.state.uploadingStates).reduce(function (accumulator, currentValue) {
        return _this4.state.uploadingStates[currentValue] || accumulator;
      }, false);
    }
  }, {
    key: "isRemoving",
    value: function isRemoving() {
      var _this5 = this;

      return Object.keys(this.state.removingStates).reduce(function (accumulator, currentValue) {
        return _this5.state.removingStates[currentValue] || accumulator;
      }, false);
    }
  }, {
    key: "updateBusyState",
    value: function updateBusyState(fileId, isBusy) {
      var _this6 = this;

      this.setState(function (prevState) {
        return {
          uploadingStates: _objectSpread(_objectSpread({}, prevState.uploadingStates), {}, _defineProperty({}, "".concat(fileId), isBusy))
        };
      }, function () {
        _this6.props.onUploadingStateChange(_this6.isBusy());
      });
    }
  }, {
    key: "updateRemovingState",
    value: function updateRemovingState(removingFileId, isBusy) {
      var _this7 = this;

      this.setState(function (prevState) {
        return {
          removingStates: _objectSpread(_objectSpread({}, prevState.removingStates), {}, _defineProperty({}, "".concat(removingFileId), isBusy))
        };
      }, function () {
        _this7.props.onRemovingStateChange(_this7.isRemoving());
      });
    }
  }, {
    key: "uploadFile",

    /**
     * Upload the file to Amazon S3 using the signed url retrieved from prop.onRequestAttachmentLocations()
     *
     * @param {string} fileId - The internal id used to identify the uploading file, to be used only within this component.
     * @param {File}   file - The browser File object to upload (https://developer.mozilla.org/en-US/docs/Web/API/File)
     * @param {string} method - HTTP verb to use for uploading the file i.e. PUT, POST etc.
     * @param {string} url - The signed url to upload the file to.
     */
    value: function uploadFile(fileId, file, method, url) {
      var _this8 = this;

      var fileReader = new FileReader(); // Used to calculate the upload ETA later on.

      var startedAt = new Date(); // Called after the file has been read as an ArrayBuffer, this is how we'll send the file

      fileReader.onload = function (e) {
        var fileBuffer = e.target.result; // Setup the request

        var req = (0, _superagent.default)(method, url).type(file.type).send(fileBuffer).on('progress', function (event) {
          /* the event is:
          	{
          		direction: "upload" or "download"
          		percent: 0 to 100 // may be missing if file size is unknown
          		total: // total file size, may be missing
          		loaded: // bytes downloaded or uploaded so far
          	}
          */
          var currentTime = new Date().getTime();
          var eta = estimateUploadEta(currentTime, startedAt.getTime(), event.percent);

          var humanisedEta = _moment.default.duration(eta).humanize();

          _this8.updateUploadState(fileId, {
            uploadProgress: event.percent / 100,
            uploadStatus: _FileList.File.Status.LOADING,
            uploadMessage: "(".concat(humanisedEta, " left)")
          });
        }); // Store the request so we can cancel/abort it later.

        _this8.uploadRequests[fileId] = req; // We'll now allow the file upload to be cancelled (this will should the remove button)

        _this8.updateUploadState(fileId, {
          canRemove: true
        }); // Kickoff the upload


        req.then(function () {
          _this8.props.onSuccess(_this8.props.bucket);

          _this8.updateBusyState(fileId, false);

          _this8.updateUploadState(fileId, {
            uploadStatus: _FileList.File.Status.SUCCESS,
            uploadMessage: null,
            complete: true
          }, function () {
            // If upload is successful promote the file to 'uploaded', it is now up to the parent to manage this
            // file via props.uploadedFiles.
            _this8.props.onFilesChanged(_this8.addFile(_this8.state.uploadingFiles[fileId]));
          });
        }).catch(function (error) {
          console.error(error);

          _this8.handleUploadError(fileId);
        });
      };

      fileReader.readAsArrayBuffer(file);
    }
    /**
     * Called when user selects a file or files to be uploaded
     * @param {Array} files - https://developer.mozilla.org/en-US/docs/Web/API/File
     */

  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/_react.default.createElement(_FileUpload.default, _extends({
        title: this.props.title,
        description: this.props.description,
        tooltip: this.props.tooltip,
        files: [].concat(_toConsumableArray(this.getUploadedFiles()), _toConsumableArray(this.getUploadingFiles())),
        onAcceptFiles: this.handleAcceptFiles,
        onRejectFiles: this.handleRejectFiles,
        maxSizeInBytes: this.props.maxSizeInBytes,
        supportedFileTypes: this.props.supportedFileTypes,
        maxFileNameLength: this.props.maxFileNameLength
      }, this.props));
    }
  }]);

  return S3BucketUpload;
}(_react.default.Component);

S3BucketUpload.defaultProps = {
  onRequestAttachmentLocations: function onRequestAttachmentLocations() {},
  onFilesChanged: function onFilesChanged() {},
  onUploadingStateChange: function onUploadingStateChange() {},
  onRemovingStateChange: function onRemovingStateChange() {},
  onSuccess: function onSuccess() {},
  uploadedFiles: [],
  minSizeInBytes: 0,
  maxSizeInBytes: DEFAULT_MAX_FILE_SIZE,
  maxFileNameLength: DEFAULT_MAX_FILE_NAME_LENGTH,
  maxSizeErrorMessage: 'Maximum file size exceeded',
  minSizeErrorMessage: 'Minimum file size not met',
  supportedFileTypes: ['.jpg', '.jpeg', '.png', '.bmp', '.tif', '.tiff', '.doc', '.docx', '.xls', '.xlsx', '.ppt', '.pptx', '.txt', '.rtf', '.zip', '.rar', '.pdf'],
  unsupportedFileTypeErrorMessage: 'Please upload valid documents type in PDF, JPEG, Powerpoint, Word, Excel formats not exceeding max file in size.',
  uploadErrorMessage: 'Error uploading file, try again',
  confirmRemovalMessage: 'Are you sure you want to remove this file?',
  title: null,
  description: null,
  tooltip: null,
  bucket: null
};
S3BucketUpload.propTypes = {
  /***
   * Function that returns a promise that resolve to the following format:
   * {
   * 		upload: {
   * 			url: 'string',
   * 			method: 'string',
   * 		},
   * 		download: {
   * 			url: 'string',
   * 			method: 'string',
   * 		},
   * 		remove: {
   * 			url: 'string',
   * 			method: 'string',
   * 		}
   * 	 }
   *
   * The File object is passed as a parameter so that you can access information about the file.
   */
  onRequestAttachmentLocations: _propTypes.default.func.isRequired,
  onUploadingStateChange: _propTypes.default.func,
  onRemovingStateChange: _propTypes.default.func,
  onFilesChanged: _propTypes.default.func,
  onSuccess: _propTypes.default.func,
  bucket: _propTypes.default.string,

  /***
   * The list of currently uploaded files
   *
   * Expects the format:
   * {
   *   id,
   *   fileName,
   *   fileSize,
   *   fileType,
   *   removeLocation: {
   *     method,
   *     url,
   *   },
   * }
   */
  uploadedFiles: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.array]),
  minSizeInBytes: _propTypes.default.number,
  maxSizeInBytes: _propTypes.default.number,
  maxFileNameLength: _propTypes.default.number,
  minSizeErrorMessage: _propTypes.default.string,
  maxSizeErrorMessage: _propTypes.default.string,
  supportedFileTypes: _propTypes.default.arrayOf(_propTypes.default.string),
  unsupportedFileTypeErrorMessage: _propTypes.default.string,
  uploadErrorMessage: _propTypes.default.string,
  confirmRemovalMessage: _propTypes.default.string,
  title: _propTypes.default.node,
  description: _propTypes.default.node,
  tooltip: _propTypes.default.node
};
var _default = S3BucketUpload;
exports.default = _default;
//# sourceMappingURL=S3BucketUpload.js.map